import React from "react";
import "./AdminDashboard.scss";
import { Breadcrumb } from "antd";
import { Link } from "react-router-dom";

const AdminDashboard: React.FC = () => {
  return (
    <div className="AdminDashboard">
      <Breadcrumb
        className="breadcrumb"
        items={[
          {
            title: "Admin",
          },
          {
            title: (
              <Link to="/admin" className="currentPage">
                Dashboard
              </Link>
            ),
          },
        ]}
      />
      <div className="dashboard-content">
        <h1>Dashboard</h1>
      </div>
    </div>
  );
};

export default AdminDashboard;
